var _rect, _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgInviteParticipants(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 137 131",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 71.199,
    height: 50.788,
    rx: 6,
    transform: "matrix(.82708 .56209 -.55636 .83094 37.945 6.11)",
    fill: "#FFBF3E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M94.428 72.558c-1.915-2.623-4.16-4.904-5.622-7.851-.827-1.667-2.448-4.562-1.507-6.513 1.711-3.552 4.374 1.283 6.037 2.4 1.153.775 3.823 3.098 4.807 4.113.847.872.332.304 1.202 1.134 2.119 2.023 4.282 3.216 5.891 5.74 2.24 3.509 2.521 7.89 2.521 12.018M95.807 79.277c-.325 1.494-.773 3.249-.868 6.34-.005 3.93.356 5.077.941 6.388.921 2.063 2.248 4.702 4.266 5.719M107.766 83.216c0 9.143 5.035 17.37 11.856 23.157 4.996 4.238 12.971 9.916 14.974 11.53M85.775 74.958c-1.059-2.09-2.517-3.634-3.704-5.428M81.344 101.083c4.68 6.42 8.254 7.707 15.084 9.642 4.918 1.394 8.683 10.226 13.219 12.511",
    stroke: "#0C0A0C",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M81.606 101.442c-2.003-3.228-2.593-4.087-4.291-7.457-1.083-2.148-2.35-4.383-2.99-6.718-.288-1.05-.546-2.697-.053-3.731.969-2.03 4.725-3.044 6.576-1.837 1.612 1.05 2.424 3.423 2.577 5.265.05.617-.415.684-.931.72-1.814.126-2.752-1.638-2.767-3.257-.018-1.977-.3-4.432 1.206-5.984.814-.837 1.79-1.215 2.924-1.215.688 0 .48.241.945.475",
    stroke: "#0C0A0C",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M90.846 125.144H59.793a2.002 2.002 0 01-1.505-.682l-4.894-5.589a2 2 0 00-1.298-.671l-49.128-5.107a.63.63 0 01.078-1.256l55.84 1.197h18.28a2 2 0 011.019.28l13.68 8.107c1.75 1.037 1.015 3.721-1.02 3.721z",
    fill: "#0C0A0C",
    stroke: "#0C0A0C",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41.91 16.27a1 1 0 00-1.949.45l1.949-.45zm45.493 35.933a1 1 0 100-2v2zM39.961 16.72l6.402 27.732 1.948-.45L41.91 16.27l-1.949.45zm16.145 35.483h31.297v-2H56.106v2zm-9.743-7.75a10 10 0 009.743 7.75v-2a8 8 0 01-7.795-6.2l-1.948.45z",
    fill: "#0C0A0C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M65.772 78.647L60.564 56.45M18.102 45.956l23.234-2.018",
    stroke: "#0C0A0C",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}

export default SvgInviteParticipants;